interface PhoneIconSize24Props {
  className?: string;
}

function PhoneIconSize24({ className }: PhoneIconSize24Props) {
  return (
    <svg
      className={className}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9375 3.25H8.0625C6.79688 3.25 5.8125 4.26953 5.8125 5.5V19C5.8125 20.2656 6.79688 21.25 8.0625 21.25H15.9375C17.168 21.25 18.1875 20.2656 18.1875 19V5.5C18.1875 4.26953 17.168 3.25 15.9375 3.25ZM12 20.125C11.3672 20.125 10.875 19.6328 10.875 19C10.875 18.4023 11.3672 17.875 12 17.875C12.5977 17.875 13.125 18.4023 13.125 19C13.125 19.6328 12.5977 20.125 12 20.125ZM15.9375 5.5V16.75H8.0625V5.5H15.9375Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default PhoneIconSize24;
